/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPlusTriangleDown: {
  name: 'plus-triangle-down';
  data: string;
} = {
  name: 'plus-triangle-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 4a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6V5a1 1 0 0 1 1-1Zm4.08 12h3.84a1 1 0 0 1 .78 1.625l-1.92 2.399a1 1 0 0 1-1.56 0l-1.92-2.4A1 1 0 0 1 16.08 16Z" fill="currentColor"/></svg>`,
};
